module.exports = __webpack_public_path__ + "img/franja-flujo.3cef8522.jpg";